<div class="card mb-0">
  <div class="flex justify-between items-start mb-3">
    <div>
      <span class="block text-muted-color font-medium text-sm mb-2">Job Executions</span>
      <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">{{ count }}</div>
    </div>
    <div class="flex items-center justify-center bg-green-100 dark:bg-green-400/10 rounded-lg" style="width: 2.25rem; height: 2.25rem">
      <i class="pi pi-cog text-green-500 text-lg"></i>
    </div>
  </div>
  <div class="flex items-center text-xs">
    <i class="pi pi-clock text-blue-500 mr-1"></i>
    <span class="text-blue-600 font-medium">{{ getLastRunText() }}</span>
  </div>
</div>
